import React from 'react';

import Image from 'next/image';

import Layout from '@/modules/core/components/Layout';

// @ts-ignore
const GameResultsPage = () => (
  <div className="mx-auto w-fit md:w-[40rem] lg:w-[60rem]  mt-24  md:mt-32 lg:mt-14 ">
    <Image
      width={2000}
      height={2000}
      src="/media/Règlements.png"
      alt="Instructions du jeu Saint-Valentin de Tayara "
      className="mx-auto w-full"
    />
    <Image
      width={2000}
      height={2000}
      src="/media/hearts.png"
      alt="Tayara Saint Valentin"
      className="-z-50 absolute top-[15rem] lg:top-0 right-0 "
    />
  </div>
);

export default GameResultsPage;

// Dynamic layout configuration
GameResultsPage.getLayout = function getLayout(page: JSX.Element) {
  return (
    <Layout>
      <Layout.Wide>{page}</Layout.Wide>
    </Layout>
  );
};
